(function () {
  let hasShown = false;
  let reopenButtonClosed = false;
  const popup = document.getElementById('promotional-popup');
  const overlay = document.getElementById('promotional-popup-overlay');
  const closeBtn = document.getElementById('promotional-popup-close');
  const reopenBtn = document.getElementById('promotional-popup-reopen');
  const reopenWrapper = document.getElementById('promotional-popup-reopen-wrapper');
  const reopenCloseBtn = document.getElementById('promotional-popup-reopen-close');

  if (!popup) {
    return;
  }

  function showPopup() {
    if (hasShown) return;
    popup.style.display = 'block';
    overlay.style.display = 'block';
    if (reopenWrapper) reopenWrapper.style.display = 'none';
    document.body.classList.add('overflow-hidden');
    hasShown = true;
  }

  function reopenPopup() {
    popup.style.display = 'block';
    overlay.style.display = 'block';
    if (reopenWrapper) reopenWrapper.style.display = 'none';
    document.body.classList.add('overflow-hidden');
  }

  function hidePopup() {
    popup.style.display = 'none';
    overlay.style.display = 'none';
    if (reopenWrapper && !reopenButtonClosed) {
      reopenWrapper.style.display = 'flex';
    }
    document.body.classList.remove('overflow-hidden');
  }

  function hideReopenButton() {
    if (reopenWrapper) {
      reopenWrapper.style.display = 'none';
      reopenButtonClosed = true;
    }
  }

  function shouldShowPopup() {
    return !sessionStorage.getItem('exitPopupShown');
  }

  function markPopupShown() {
    sessionStorage.setItem('exitPopupShown', '1');
  }

  if (closeBtn) closeBtn.addEventListener('click', () => {
    hidePopup();
    markPopupShown();
  });

  if (overlay) overlay.addEventListener('click', () => {
    hidePopup();
    markPopupShown();
  });

  if (reopenBtn) reopenBtn.addEventListener('click', reopenPopup);

  if (reopenCloseBtn) reopenCloseBtn.addEventListener('click', hideReopenButton);

  function isDesktop() {
    return window.innerWidth > 768;
  }

  // Verifica se o popup já foi fechado e mostra o botão de reabrir (mobile e desktop)
  if (sessionStorage.getItem('exitPopupShown') && 
      !reopenButtonClosed && 
      reopenWrapper) {
    reopenWrapper.style.display = 'flex';
  }

  if (shouldShowPopup()) {
    setTimeout(function() {
      showPopup();
      markPopupShown();
    }, 5000);
  }

  window.addEventListener('resize', function () {
    // Atualiza a exibição do botão de reabrir ao redimensionar
    if (sessionStorage.getItem('exitPopupShown') && 
        !reopenButtonClosed && 
        reopenWrapper) {
      reopenWrapper.style.display = 'flex';
    }
  });
})();